import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { Clock, Shield, Check, AlertTriangle, TrendingUp, Star } from 'lucide-react';
export function PricingSection() {
  // Simple countdown logic for visual effect
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 58,
    s: 45
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section id="pricing" className="bg-zinc-950 text-white py-24 px-4" data-id="element-135">
      <div className="max-w-5xl mx-auto" data-id="element-136">
        {/* URGENCY BANNER */}
        <div className="bg-red-600 rounded-2xl p-6 text-center mb-16 shadow-2xl shadow-red-900/20 border border-red-500" data-id="element-137">
          <div className="flex items-center justify-center gap-2 text-red-100 font-bold uppercase tracking-widest text-sm mb-4" data-id="element-138">
            <Clock className="w-5 h-5" data-id="element-139" /> Precio de lanzamiento — Cierra en:
          </div>
          <div className="font-display font-black text-5xl md:text-7xl tracking-tight mb-6" data-id="element-140">
            {String(timeLeft.h).padStart(2, '0')} :{' '}
            {String(timeLeft.m).padStart(2, '0')} :{' '}
            {String(timeLeft.s).padStart(2, '0')}
          </div>
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-lg font-medium" data-id="element-141">
            <span className="flex items-center gap-2" data-id="element-142">
              <AlertTriangle className="w-5 h-5" data-id="element-143" /> Después sube $8.000 ARS. No
              vuelve.
            </span>
            <span className="hidden md:inline" data-id="element-144">•</span>
            <span className="text-red-200" data-id="element-145">🔴 68% de los cupos ya tomados</span>
          </div>
        </div>

        <div className="text-center mb-12" data-id="element-146">
          <h2 className="font-display font-black text-4xl md:text-5xl uppercase" data-id="element-147">
            Elegí tu Super Combo
          </h2>
        </div>

        {/* PRICING CARDS */}
        <div className="grid md:grid-cols-2 gap-8 mb-20" data-id="element-148">
          {/* Basic Pack */}
          <div className="bg-zinc-900 border border-zinc-800 rounded-3xl p-8 flex flex-col" data-id="element-149">
            <div className="mb-8" data-id="element-150">
              <h3 className="font-display font-black mb-2 text-white text-[28px] uppercase" data-id="element-151">
                Super Combo Pérdida de Peso 40+
              </h3>
              <p className="text-gray-400" data-id="element-152">
                Ideal para: Mujeres 35-52 años que quieren bajar de peso
                equilibrando hormonas con comida real argentina
              </p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-153">
              <li className="flex items-center gap-3" data-id="element-154">
                <Check className="text-brand w-5 h-5 shrink-0" data-id="element-155" /> 6 Tomos
                Completos
              </li>
              <li className="flex items-center gap-3" data-id="element-156">
                <Check className="text-brand w-5 h-5 shrink-0" data-id="element-157" /> 6 Bonos
                Estratégicos
              </li>
              <li className="flex items-center gap-3" data-id="element-158">
                <Check className="text-brand w-5 h-5 shrink-0" data-id="element-159" /> Acceso de por
                vida
              </li>
              <li className="flex items-center gap-3" data-id="element-160">
                <Check className="text-brand w-5 h-5 shrink-0" data-id="element-161" />{' '}
                Actualizaciones gratis
              </li>
            </ul>

            <div className="mb-8" data-id="element-162">
              <div className="text-gray-500 line-through text-xl mb-1" data-id="element-163">
                $41.000 ARS
              </div>
              <div className="font-display font-black text-white text-[40px]" data-id="element-164">
                $18.990{' '}
                <span className="text-2xl text-gray-400 font-sans font-bold" data-id="element-165">
                  ARS
                </span>
              </div>
            </div>

            <Button fullWidth variant="outline" onClick={() => window.location.href = 'https://www.bibliotecapro.online/cart/53448416461107:1'} data-id="element-166">
              QUIERO MI SUPER COMBO AHORA
            </Button>
          </div>

          {/* Premium Pack */}
          <div className="bg-gradient-to-b from-brand/20 to-zinc-900 border-2 border-brand rounded-3xl p-8 flex flex-col relative transform md:-translate-y-4 shadow-2xl shadow-brand/20" data-id="element-167">
            <div className="absolute -top-5 left-1/2 -translate-x-1/2 bg-brand text-white font-bold uppercase tracking-wider py-1 px-4 rounded-full text-sm whitespace-nowrap" data-id="element-168">
              ⭐ MÁS VENDIDO
            </div>

            <div className="mb-8" data-id="element-169">
              <h3 className="font-display font-black mb-2 text-white text-[28px] uppercase" data-id="element-170">
                SUPER COMBO + ACELERADOR
              </h3>
              <p className="text-brand-light font-medium" data-id="element-171">
                Ideal para: Mujeres que además quieren eliminar la flacidez,
                activar el músculo y recuperar la energía vital sin pisar un
                gimnasio
              </p>
            </div>

            <ul className="space-y-4 mb-8 flex-grow" data-id="element-172">
              <li className="flex items-center gap-3" data-id="element-173">
                <Check className="text-brand w-5 h-5 shrink-0" data-id="element-174" />{' '}
                <strong className="text-white" data-id="element-175">Todo lo del Super Combo</strong>
              </li>
              <li className="flex items-center gap-3" data-id="element-176">
                <Check className="text-brand w-5 h-5 shrink-0" data-id="element-177" /> Sistema de
                Tonificación en Casa
              </li>
              <li className="flex items-center gap-3" data-id="element-178">
                <Check className="text-brand w-5 h-5 shrink-0" data-id="element-179" /> Rutinas Nivel
                1 y 2
              </li>
              <li className="flex items-center gap-3" data-id="element-180">
                <Check className="text-brand w-5 h-5 shrink-0" data-id="element-181" /> Circuito Adiós
                Flacidez
              </li>
              <li className="flex items-center gap-3" data-id="element-182">
                <Check className="text-brand w-5 h-5 shrink-0" data-id="element-183" /> Nutrición
                Post-Entrenamiento
              </li>
            </ul>

            <div className="mb-8" data-id="element-184">
              <div className="text-gray-500 line-through text-xl mb-1" data-id="element-185">
                $49.000 ARS
              </div>
              <div className="font-display font-black text-brand-light text-[40px]" data-id="element-186">
                $26.990{' '}
                <span className="text-2xl text-gray-400 font-sans font-bold" data-id="element-187">
                  ARS
                </span>
              </div>
            </div>

            <Button fullWidth onClick={() => window.location.href = 'https://www.bibliotecapro.online/cart/53448421114163:1'} data-id="element-188">
              QUIERO EL SUPER COMBO + ACELERADOR
            </Button>
          </div>
        </div>

        {/* UPSELL EXPLANATION */}
        <div className="bg-zinc-900 rounded-3xl p-8 md:p-12 border border-zinc-800 mb-12" data-id="element-189">
          <div className="text-center mb-10" data-id="element-190">
            <TrendingUp className="w-12 h-12 text-brand mx-auto mb-4" data-id="element-191" />
            <h3 className="font-display font-black text-3xl uppercase" data-id="element-192">
              ¿Qué agrega el Acelerador Metabólico 40+?
            </h3>
          </div>

          <div className="overflow-x-auto" data-id="element-193">
            <table className="w-full text-left border-collapse" data-id="element-194">
              <thead data-id="element-195">
                <tr className="border-b-2 border-zinc-800" data-id="element-196">
                  <th className="py-4 px-4 text-gray-400 font-bold uppercase" data-id="element-197">
                    Situación real
                  </th>
                  <th className="py-4 px-4 text-red-400 font-bold uppercase" data-id="element-198">
                    ❌ Sin el Acelerador
                  </th>
                  <th className="py-4 px-4 text-brand font-bold uppercase" data-id="element-199">
                    ✅ Con el Acelerador
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-zinc-800" data-id="element-200">
                <tr data-id="element-201">
                  <td className="py-4 px-4 font-medium" data-id="element-202">
                    Bajás de peso pero la piel queda flácida
                  </td>
                  <td className="py-4 px-4 text-gray-400" data-id="element-203">
                    No tenés protocolo
                  </td>
                  <td className="py-4 px-4 text-white font-bold" data-id="element-204">
                    Circuito Anti-Flacidez — 25 minutos
                  </td>
                </tr>
                <tr data-id="element-205">
                  <td className="py-4 px-4 font-medium" data-id="element-206">
                    Querés quemar más sin ir al gimnasio
                  </td>
                  <td className="py-4 px-4 text-gray-400" data-id="element-207">No sabés cómo</td>
                  <td className="py-4 px-4 text-white font-bold" data-id="element-208">
                    Rutinas Nivel 1 y 2 en casa
                  </td>
                </tr>
                <tr data-id="element-209">
                  <td className="py-4 px-4 font-medium" data-id="element-210">
                    Energía baja que no mejora solo con dormir
                  </td>
                  <td className="py-4 px-4 text-gray-400" data-id="element-211">
                    Sin solución muscular
                  </td>
                  <td className="py-4 px-4 text-white font-bold" data-id="element-212">
                    Protocolo de activación matutina 5 min
                  </td>
                </tr>
                <tr data-id="element-213">
                  <td className="py-4 px-4 font-medium" data-id="element-214">
                    Metabolismo que se frena con los años
                  </td>
                  <td className="py-4 px-4 text-gray-400" data-id="element-215">Solo alimentación</td>
                  <td className="py-4 px-4 text-white font-bold" data-id="element-216">
                    Músculo activo que quema 24/7
                  </td>
                </tr>
                <tr data-id="element-217">
                  <td className="py-4 px-4 font-medium" data-id="element-218">
                    Glúteos y piernas sin tono
                  </td>
                  <td className="py-4 px-4 text-gray-400" data-id="element-219">
                    Sin rutina específica
                  </td>
                  <td className="py-4 px-4 text-white font-bold" data-id="element-220">
                    Rutina completa piernas y glúteos
                  </td>
                </tr>
                <tr data-id="element-221">
                  <td className="py-4 px-4 font-medium" data-id="element-222">
                    No sabés qué comer después de entrenar
                  </td>
                  <td className="py-4 px-4 text-gray-400" data-id="element-223">
                    Sin guía post-ejercicio
                  </td>
                  <td className="py-4 px-4 text-white font-bold" data-id="element-224">
                    Nutrición post-entrenamiento incluida
                  </td>
                </tr>
                <tr data-id="element-225">
                  <td className="py-4 px-4 font-medium" data-id="element-226">
                    Dolores articulares crónicos
                  </td>
                  <td className="py-4 px-4 text-gray-400" data-id="element-227">Sin movilidad</td>
                  <td className="py-4 px-4 text-white font-bold" data-id="element-228">
                    Protocolo anti-dolor y anti-cortisol
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* ACELERADOR INCLUDES */}
        <div className="bg-zinc-900 rounded-3xl p-8 md:p-12 border border-zinc-800 mb-20" data-id="element-229">
          <div className="text-center mb-10" data-id="element-230">
            <h3 className="font-display font-black text-3xl uppercase text-brand" data-id="element-231">
              ✅ EL ACELERADOR INCLUYE:
            </h3>
          </div>

          <div className="overflow-x-auto" data-id="element-232">
            <table className="w-full text-left border-collapse" data-id="element-233">
              <thead data-id="element-234">
                <tr className="border-b-2 border-zinc-800" data-id="element-235">
                  <th className="py-4 px-4 text-gray-400 font-bold uppercase" data-id="element-236">
                    Protocolo
                  </th>
                  <th className="py-4 px-4 text-white font-bold uppercase" data-id="element-237">
                    Detalle
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-zinc-800" data-id="element-238">
                <tr data-id="element-239">
                  <td className="py-4 px-4 font-medium text-brand" data-id="element-240">
                    ☀️ Activación matutina 5 minutos
                  </td>
                  <td className="py-4 px-4 text-gray-300" data-id="element-241">
                    Activa el metabolismo y regula el cortisol desde temprano
                  </td>
                </tr>
                <tr data-id="element-242">
                  <td className="py-4 px-4 font-medium text-brand" data-id="element-243">
                    💪 Rutina Nivel 1 — El Despertar Muscular
                  </td>
                  <td className="py-4 px-4 text-gray-300" data-id="element-244">
                    22 minutos — para empezar sin experiencia previa
                  </td>
                </tr>
                <tr data-id="element-245">
                  <td className="py-4 px-4 font-medium text-brand" data-id="element-246">
                    💪 Rutina Nivel 2 — Fuerza y Definición
                  </td>
                  <td className="py-4 px-4 text-gray-300" data-id="element-247">
                    28 minutos — para construir músculo real
                  </td>
                </tr>
                <tr data-id="element-248">
                  <td className="py-4 px-4 font-medium text-brand" data-id="element-249">
                    🔥 Circuito Adiós Flacidez
                  </td>
                  <td className="py-4 px-4 text-gray-300" data-id="element-250">
                    Brazos, pecho y abdomen en 25 minutos
                  </td>
                </tr>
                <tr data-id="element-251">
                  <td className="py-4 px-4 font-medium text-brand" data-id="element-252">
                    🦵 Piernas y Glúteos Fuertes
                  </td>
                  <td className="py-4 px-4 text-gray-300" data-id="element-253">
                    El motor metabólico más activo del cuerpo
                  </td>
                </tr>
                <tr data-id="element-254">
                  <td className="py-4 px-4 font-medium text-brand" data-id="element-255">
                    🧘 Movilidad Anti-Dolor
                  </td>
                  <td className="py-4 px-4 text-gray-300" data-id="element-256">
                    Menos cortisol, menos rigidez, más calma
                  </td>
                </tr>
                <tr data-id="element-257">
                  <td className="py-4 px-4 font-medium text-brand" data-id="element-258">
                    📅 Calendario 4 Semanas
                  </td>
                  <td className="py-4 px-4 text-gray-300" data-id="element-259">
                    Sin improvisar — semana a semana planificada
                  </td>
                </tr>
                <tr data-id="element-260">
                  <td className="py-4 px-4 font-medium text-brand" data-id="element-261">
                    🥗 Nutrición Post-Entrenamiento
                  </td>
                  <td className="py-4 px-4 text-gray-300" data-id="element-262">
                    Qué comer para que el músculo crezca
                  </td>
                </tr>
                <tr data-id="element-263">
                  <td className="py-4 px-4 font-medium text-brand" data-id="element-264">
                    📊 Registro de Victorias Físicas
                  </td>
                  <td className="py-4 px-4 text-gray-300" data-id="element-265">
                    Tu evidencia de transformación corporal
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        {/* MORE TESTIMONIALS */}
        <div className="mb-20" data-id="element-266">
          <h3 className="font-display font-black text-3xl md:text-4xl uppercase text-center mb-10" data-id="element-267">
            ❤️ MÁS MUJERES QUE YA ESTÁN EN PROCESO
          </h3>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-268">
            <div className="bg-zinc-900 border border-zinc-800 p-8 rounded-xl" data-id="element-269">
              <div className="flex text-brand mb-4" data-id="element-270">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-271" />)}
              </div>
              <p className="text-lg italic text-gray-300 mb-6" data-id="element-272">
                "El Tomo 3 me cambió la vida. Entendí que mi problema era el
                cortisol, no la comida. En 2 semanas dormí mejor que en años."
              </p>
              <div className="font-bold text-white" data-id="element-273">Cecilia R. 📍 Mendoza</div>
              <div className="text-brand text-sm font-medium" data-id="element-274">
                Super Combo + Acelerador
              </div>
            </div>
            <div className="bg-zinc-900 border border-zinc-800 p-8 rounded-xl" data-id="element-275">
              <div className="flex text-brand mb-4" data-id="element-276">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-277" />)}
              </div>
              <p className="text-lg italic text-gray-300 mb-6" data-id="element-278">
                "Con los menús de 10 minutos del Bono 4 dejé de pedir delivery
                cuando estoy cansada. Eso solo ya vale todo el combo."
              </p>
              <div className="font-bold text-white" data-id="element-279">
                Patricia M. 📍 Buenos Aires
              </div>
              <div className="text-brand text-sm font-medium" data-id="element-280">Super Combo</div>
            </div>
            <div className="bg-zinc-900 border border-zinc-800 p-8 rounded-xl" data-id="element-281">
              <div className="flex text-brand mb-4" data-id="element-282">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-283" />)}
              </div>
              <p className="text-lg italic text-gray-300 mb-6" data-id="element-284">
                "El Tomo 5 de ayuno fue revelador. Siempre lo hice mal. Ahora lo
                hago para mi etapa hormonal y la diferencia es enorme."
              </p>
              <div className="font-bold text-white" data-id="element-285">Sofía C. 📍 La Plata</div>
              <div className="text-brand text-sm font-medium" data-id="element-286">Super Combo</div>
            </div>
            <div className="bg-zinc-900 border border-zinc-800 p-8 rounded-xl" data-id="element-287">
              <div className="flex text-brand mb-4" data-id="element-288">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-289" />)}
              </div>
              <p className="text-lg italic text-gray-300 mb-6" data-id="element-290">
                "Bajé 6 cm de cintura en el primer mes. La balanza casi no se
                movió pero la ropa cuenta otra historia."
              </p>
              <div className="font-bold text-white" data-id="element-291">Ana L. 📍 Rosario</div>
              <div className="text-brand text-sm font-medium" data-id="element-292">
                Super Combo + Acelerador
              </div>
            </div>
          </div>
        </div>

        {/* GUARANTEE */}
        <div className="max-w-3xl mx-auto bg-white text-black rounded-3xl p-8 md:p-12 text-center border-4 border-brand" data-id="element-293">
          <Shield className="w-16 h-16 text-brand mx-auto mb-6" data-id="element-294" />
          <h3 className="font-display font-black text-3xl md:text-4xl uppercase mb-6" data-id="element-295">
            Garantía 7 Días — Sin Preguntas
          </h3>
          <p className="text-lg text-gray-700 mb-6 font-medium" data-id="element-296">
            Abrís los tomos. Los aplicás en tu vida. Si en 7 días no es lo que
            esperabas: devolución del 100% sin formularios, sin drama, sin
            explicaciones.
          </p>
          <p className="text-xl font-bold text-brand" data-id="element-297">
            Tasa de devoluciones: menos del 1%.
          </p>
        </div>
      </div>
    </section>;
}